/**
 * `cn` — conditional className joiner. Thin re-export of clsx so components have
 * a single import for class composition (kept separate in case we later swap in
 * tailwind-merge for conflict resolution).
 */
import { clsx, type ClassValue } from "clsx";

export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
